import React, { useEffect } from 'react';
import '../styles/ToolsPage.css';

const ICONS = {
  chart: (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M6 8v16h20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        d="M10 20l4-6 5 4 5-10"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="20" r="1.8" fill="currentColor" />
      <circle cx="14" cy="14" r="1.8" fill="currentColor" />
      <circle cx="19" cy="18" r="1.8" fill="currentColor" />
      <circle cx="24" cy="8" r="1.8" fill="currentColor" />
    </svg>
  ),
  beaker: (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M11 6h10v3l4 12c.6 1.9-.8 3.9-2.8 3.9H9.8C7.8 24.9 6.4 23 7 21l4-12z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14h10m-9 4.5h8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="13" cy="11" r="1.4" fill="currentColor" />
      <circle cx="19" cy="12" r="1.2" fill="currentColor" />
    </svg>
  ),
  arrows: (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M8 10h12M18 6l4 4-4 4m6 6H12m6-4 4 4-4 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="10" r="1.5" fill="currentColor" />
      <circle cx="22" cy="22" r="1.5" fill="currentColor" />
    </svg>
  ),
  document: (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path
        d="M12 6h8l6 6v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path
        d="M20 6v6h6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M11 18l3.5-2.5 2.5 3 4-5 2 2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const TOOL_CARDS = [
  {
    key: 'Offset Yield Strength',
    title: 'Offset Yield Strength',
    description: 'Upload stress-strain data to auto-detect the elastic segment and compute 0.2% offset yield.',
    button: 'Open tool',
    icon: 'chart',
    tint: '#0ea5e9',
    background: 'linear-gradient(135deg, #ecfeff, #dbeafe)',
  },
  {
    key: 'Mixture Density',
    title: 'Rule of Mixtures Density',
    description: 'Estimate theoretical density from atomic% or weight% using element densities.',
    button: 'Open tool',
    icon: 'beaker',
    tint: '#10b981',
    background: 'linear-gradient(135deg, #ecfdf3, #dcfce7)',
  },
  {
    key: 'Mass-Atomic Converter',
    title: 'Atomic to Weight Converter',
    description: 'Convert between atomic% and weight% using standard atomic weights.',
    button: 'Open tool',
    icon: 'arrows',
    tint: '#f97316',
    background: 'linear-gradient(135deg, #fff7ed, #ffedd5)',
  },
  {
    key: 'Data Extraction',
    title: 'Auto Data Extraction',
    description: 'Convert PDFs into structured datasets with summaries, logs, and CSV export.',
    button: 'Open Auto Data',
    icon: 'document',
    tint: '#6366f1',
    background: 'linear-gradient(135deg, #eef2ff, #e0e7ff)',
  },
];

function ToolsHomePage({ onNavigate }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const canNavigate = typeof onNavigate === 'function';
  const handleOpen = (submenu) => {
    if (!canNavigate) return;
    onNavigate(submenu, 'tools');
  };

  return (
    <div className="tools-page">
      <div className="tools-header">
        <div className="tools-badge">MATAI Tools</div>
        <h1 className="tools-title">Toolbox</h1>
        <p className="tools-subtitle">
          Pick a tool to run.
        </p>
      </div>

      <div className="tools-library">
        <div className="tools-library-grid">
          {TOOL_CARDS.map((tool) => (
            <div className="tools-card tools-library-card" key={tool.key}>
              <div className="tools-library-left">
                <div className="tools-library-icon" style={{ background: tool.background, color: tool.tint }}>
                  {ICONS[tool.icon]}
                </div>
                <div className="tools-library-meta">
                  <p className="tools-library-name">{tool.title}</p>
                  <p className="tools-library-desc">{tool.description}</p>
                </div>
              </div>
              <button
                className="tools-primary-button"
                type="button"
                onClick={() => handleOpen(tool.key)}
                disabled={!canNavigate}
              >
                {tool.button}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ToolsHomePage;
